import { faEye } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { GetFacturasAceptablesDtoProps } from "api/DTOs/GetFacturasAceptablesDto"
import { GetPagaresAceptablesDtoProps } from "api/DTOs/GetPagaresAceptablesDto"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"

export const FINANCIACION_DETAIL_COLUMNS = (
  t: TFunction,
  setRowSelected: $TSMigrationFixMe
) => {
  const columns = [
    {
      key: "numero",
      header: `${t("documentos.validar.tab.headerNum")}`,
      field: "numero",
    },
    {
      key: "librador.razonSocial",
      header: `${t("documentos.validar.tab.headerCompanyName")}`,
      field: "librador.razonSocial",
    },
    {
      key: "librador.nif",
      header: `${t("documentos.validar.tab.headerNif")}`,
      field: "librador.nif",
    },
    {
      key: "fechaEmision",
      header: `${t("documentos.validar.tab.headerDateEmision")}`,
      field: "fechaEmision",
      body: ({
        fechaEmision,
      }: GetFacturasAceptablesDtoProps | GetPagaresAceptablesDtoProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "-",
    },
    {
      key: "importe",
      header: `${t("documentos.validar.tab.headerTax")}`,
      field: "importe",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      body: ({
        importe,
      }: GetFacturasAceptablesDtoProps | GetPagaresAceptablesDtoProps) =>
        frontendCurrency(importe ?? 0),
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      body: (
        rowData: GetFacturasAceptablesDtoProps | GetPagaresAceptablesDtoProps
      ) => {
        if (!rowData.id) return
        return (
          <div
            onClick={() => {
              setRowSelected(rowData.id)
            }}
            className='flex items-center justify-center cursor-pointer tw-h-9 tw-w-9 tw-bg-white tw-rounded-md tw-shadow-md'
          >
            <FontAwesomeIcon icon={faEye} />
          </div>
        )
      },
    },
  ]
  return columns
}
